import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/resetPassword";
import deltas from "../../actions/deltas";

const {SET_RESET_PASSWORD_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_RESET_PASSWORD_STATE);
